import { SelectOption } from 'components/inputs/BaseSelect';
import Immutable from 'immutable';

export interface RawSubmittalStatus {
  kind: string;
  display: string;
}

export interface SubmittalStatusData {
  kind: string;
  display: string;
}

const defaultValues: SubmittalStatusData = {
  kind: '',
  display: '',
};

export const SubmittalStatusFactory = Immutable.Record(
  defaultValues,
  'SubmittalStatus'
);

export class SubmittalStatus extends SubmittalStatusFactory {
  serialize(): RawSubmittalStatus {
    return this.toJS();
  }

  toSelectOption(): SelectOption {
    return {
      label: this.display,
      value: this.kind,
    };
  }

  static deserialize(rawSubmittalStatus: RawSubmittalStatus): SubmittalStatus {
    return new SubmittalStatus({
      ...rawSubmittalStatus,
    });
  }

  static fromSelectOption(sc: SelectOption): SubmittalStatus {
    return new SubmittalStatus({
      kind: sc.value,
      display: sc.label,
    });
  }
}

export type SubmittalStatusList = Immutable.List<SubmittalStatus>;
